import { ApiEndpoint } from './ApiDefinition';

export type Dashboard = {
    id: number,
    /** The EMBEDDED uuid (environment-local). What this app's workpage picker stores. */
    uuid: string,
    /** The NATIVE uuid (portable). What the embed-token endpoint resolves. */
    nativeUuid?: string,
    name: string,
    thumbnailUrl: string,
}

export type DashboardEmbedToken = {
  url: string,
  token: string,
  /** The EMBEDDED uuid resolved by the backend — what `embedDashboard({ id })` must receive. */
  embeddedUuid: string,
  /**
   * The slug of the tenant the dashboard belongs to, resolved by the backend from the dashboard's
   * own ownership. It goes on the embed url so the iframe's page load knows whose colours to use:
   * that request is anonymous by Superset's own design, and the guest token only reaches the API
   * calls that come after it.
   */
  tenantSlug?: string,
}

const ReportsApi = {
  getReportsBackendUrl: ApiEndpoint<void, string>({
    url: 'manage/reports/backend-url',
  }),
  listDashboards: ApiEndpoint<void, Dashboard[]>({
    url: 'manage/reports/dashboards/list',
  }),
  getDashboardEmbedToken: ApiEndpoint<{dashboardUuid: string, constraints?: { dataset: number, clause: string }[]}, DashboardEmbedToken>({
    url: ({
      dashboardUuid
    }) => `manage/reports/dashboards/${dashboardUuid}/token`,
    method: 'post',
    body: ({ constraints }) => constraints ?? [],
  }),
};

export default ReportsApi;